// extracted by mini-css-extract-plugin
module.exports = {"content":"reconciliationMessage_content__B5nxb","tabs":"reconciliationMessage_tabs__2bMCL","backsButtton":"reconciliationMessage_backsButtton__3z4sh"};